module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-content/enrollee-zero-state@3x.png"